import { serviceMaker } from "..";
import { IActiveInactive, IPagination } from "../../data/AppInterface";
import { IGalleryDirectoryData } from "../../screens/gallery-directory/GalleryDirectoryFormController";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

export const GET_ALL_GALLERY_DIRECTORY = (
  pagination: IPagination,
  search: string,
  advanceSearch: string
) => {
  const searchGender =
    advanceSearch.length > 0 ? `&gender=${advanceSearch}` : "";
  return serviceMaker(
    API_ENDPOINTS.get_all_gallery_directory.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }${searchGender}`,
    API_ENDPOINTS.get_all_gallery_directory.method
  );
};

export const GET_GALLERY_DIRECTORY_BY_ID = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.get_all_gallery_directory.url + `/${id}`,
    API_ENDPOINTS.get_all_gallery_directory.method
  );
};

export const CREATE_GALLERY_DIRECTORY = (payload: IGalleryDirectoryData) => {
  return serviceMaker(
    API_ENDPOINTS.create_gallery_directory.url,
    API_ENDPOINTS.create_gallery_directory.method,
    payload
  );
};

export const UPDATE_GALLERY_DIRECTORY = (
  payload: IGalleryDirectoryData,
  id: string
) => {
  return serviceMaker(
    API_ENDPOINTS.update_gallery_directory.url + `/${id}`,
    API_ENDPOINTS.update_gallery_directory.method,
    payload
  );
};

export const DELETE_GALLERY_DIRECTORY = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_gallery_directory.url + `/${id}`,
    API_ENDPOINTS.delete_gallery_directory.method
  );
};
